import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2218_holiday_calendar_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Holiday Calendars",
        fabAction: {
            type: "add",
            screenId: "2219",
        },
        style: {
            backgroundColor: "#F9FAFB"
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        Name: "holiday_calendar_summary",
                        apiname: "holiday_calendar_summary",
                        titleValue: "calendar_name",
                        Form: {
                            Name: "holiday_calendar_summary",
                            TableName: "holiday_calendar",
                            Query: "SELECT holiday_calendar.id, holiday_calendar.calendar_name, holiday_calendar.calendar_year, branches.name AS transaction_branch_id, holiday_calendar.status, holiday_calendar.modified_at FROM holiday_calendar LEFT JOIN branches ON branches.id::text = holiday_calendar.transaction_branch_id::text WHERE holiday_calendar.soft_delete = 0",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Calendar Name",
                                    BindValue: "calendar_name",
                                    Json_Attribute: "calendar_name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Year",
                                    BindValue: "calendar_year",
                                    Json_Attribute: "calendar_year",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Branch",
                                    BindValue: "transaction_branch_id",
                                    Json_Attribute: "transaction_branch_id",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Status",
                                    BindValue: "status",
                                    Json_Attribute: "status",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Last Updated",
                                    BindValue: "modified_at",
                                    Json_Attribute: "modified_at",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true
                                }
                            ]
                        },
                        SummeryActions: [
                            {
                                ActionType: "View",
                                Label: "View Details",
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "holiday_calendar_details/<id>",
                                },
                                ScreenId: "2220",
                            },
                            {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "hrm/holiday_calendar_add/<id>"
                                },
                                ActionType: "Edit",
                                ScreenId: "2219"
                            },
                            {
                                Action: {
                                    Action: "Delete",
                                    Module: "holiday_calendar"
                                },
                                ActionType: "Delete"
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
